import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faBan,
  faCircle,
  faDesktop,
  faPhone,
  faWindow,
  faLaptop,
} from 'lib/font_awesome/regular';
import * as propTypes from 'lib/prop_types';

// oxlint-disable-next-line local-rules/css_modules
import './technical_requirements.css';

function TechnicalRequirements({
  browser,
  device,
  forbidden,
  phone,
  recording,
  os,
}) {
  return (
    <>
      {phone && (
        <div className="TechnicalRequirements__tech-detail-item">
          <FontAwesomeIcon className="icon-left" icon={faPhone} />
          {phone}
        </div>
      )}
      {device && (
        <div className="TechnicalRequirements__tech-detail-item">
          <FontAwesomeIcon className="icon-left" icon={faDesktop} />
          {device}
        </div>
      )}
      {os && (
        <div className="TechnicalRequirements__tech-detail-item">
          <FontAwesomeIcon className="icon-left" icon={faLaptop} />
          {os}
        </div>
      )}
      {browser && (
        <div className="TechnicalRequirements__tech-detail-item">
          <FontAwesomeIcon className="icon-left" icon={faWindow} />
          {browser}
        </div>
      )}
      {recording && (
        <div className="TechnicalRequirements__tech-detail-item">
          <FontAwesomeIcon className="icon-left" icon={faCircle} />
          {recording}
        </div>
      )}
      {forbidden && (
        <div className="TechnicalRequirements__tech-detail-item">
          <FontAwesomeIcon className="icon-left" icon={faBan} />
          {forbidden}
        </div>
      )}
    </>
  );
}

TechnicalRequirements.propTypes = {
  browser: propTypes.string,
  device: propTypes.string,
  forbidden: propTypes.string,
  os: propTypes.string,
  phone: propTypes.string,
  recording: propTypes.string,
};

export default TechnicalRequirements;
